import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormGroupDirective,
  FormControl,
  NgForm,
  Validators,
} from "@angular/forms";

import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader"; 
import { Router } from '@angular/router';
import { Location } from "@angular/common";
import { WalletService } from "../services/wallet.service";
import { environment } from "src/environments/environment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";

@Component({
  selector: 'app-recharge-wallet',
  templateUrl: './recharge-wallet.component.html',
  styleUrls: ['./recharge-wallet.component.scss']
})
export class RechargeWalletComponent implements OnInit {
  uploadRecipt: boolean = false;
  role: any;
  isAlliance: boolean = false;
  isDistributor: boolean = false;
  requestMoney: FormGroup;
  requestMoney2: FormGroup;
  RecieptName: any = "";
  Reciept: any;
  uacid: any;
  email: any;
  unique_Nmae: any;
  bankDATA: any = [];
  selected = 'option1';
  receipt: boolean = true;
  reqHistory: boolean;
  wallet:boolean
  WalletRechargeStatus: any;
  openReq: boolean=true;
  closeReq: boolean;
  rejectReq: boolean;
  imageUrl: any;
  blockIndex: any;
  closeResult: string;
  OpenImg: any;
  bankYMDATA: any;
  constructor(  private fb: FormBuilder,
    private auth: WalletService,
    private toast: ToastrService,
    private ngx: NgxUiLoaderService,
    private modalService: NgbModal,
    private route : Router,
    private location:Location) {
      this.requestMoney = this.fb.group({
        amount: ["", [Validators.required],this.validateInputAsync],
        bank: ["", [Validators.required]],
        txnref:["", [Validators.required]],
        remarks: ["", [Validators.required]],
        yourbank:["",[Validators.required]]
  
      });
      this.email =  localStorage.getItem('emailId');
      this.uacid = localStorage.getItem("uacid")
    this.getbank();

     }
     validateInputAsync(control: FormControl): Promise<any> | Observable<any> {
      return new Promise((resolve) => {
        if (control.value > 1000000) {
          resolve({ maxValueExceeded: true });
        } else {
          resolve(null);
        }
      });
    }
     getbank() {
      this.auth.getBankList().subscribe((res: any) => {
        this.bankDATA = res.object;
      });
    }
    getRegisteredbankOfYM(){
      
      // this.auth.getBankListofYM().subscribe((res: any) => {
      //   this.bankYMDATA = res.data;
      // });
      this.auth.getBankListofYM2().subscribe((res: any) => {
        this.bankYMDATA = res.object;
      });
    }
  ngOnInit(): void {
    this.imageUrl = environment.retailerimageUrl;
    this.getRegisteredbankOfYM();
  }

  openmodalforUserDeletion(id,modal,i) {
    console.log(id);
   
  let foundIndex = this.WalletRechargeStatus.findIndex((f: any) => f._id == id);
  console.log(this.WalletRechargeStatus[foundIndex])
  this.OpenImg=this.WalletRechargeStatus[foundIndex].proof
    this.blockIndex=i;
   
    // document.getElementById("tab-pane-id01").click();
    this.modalService.open(modal, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      // this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  
  onSubmit(form) {
    console.log("onsubmit",form)
    console.log(this.Reciept);
    if(this.Reciept == undefined && !this.uploadRecipt){
    this.toast.error('Please Upload Receipt')
    }else{
      this.ngx.start();
      // this.auth
      //   .RequestMoneywithUpload(
      //     this.email,
      //     this.uacid,
      //     this.Reciept,
      //     this.unique_Nmae,
      //     form.amount,
      //     form.bank,
      //     form.txnref,
      //     form.remarks
      //   )
      //   .subscribe(
      //     (res: any) => {
      //       this.ngx.stop();
      //       if(res.status_code==200){
      //         this.toast.success(res.msg);
      //          this.route.navigate(['/dashboard'])
      //       }
      //       // this.toast.success(res.msg);
      //       // this.requestMoney.reset();

      //     },
      //     (err) => {
      //       this.ngx.stop();
      //       this.toast.error(err.error.message);
      //     }
      //   );
      this.auth
      .RequestMoneywithUpload2(
        form.amount,
        this.Reciept,
        form.remarks,
        form.bank,
        form.yourbank,
        form.txnref,
      )
      .subscribe(
        (res: any) => {
          this.ngx.stop();
          if(res.status_code==1){
            this.toast.success(res.message);
             this.route.navigate(['/dashboard'])
          }
          // this.toast.success(res.msg);
          // this.requestMoney.reset();

        },
        (err) => {
          this.ngx.stop();
          this.toast.error(err.error.message);
        }
      );
    }
    
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  triggerFile(fileInput) {
    fileInput.click();
  }

  uploadRecipt1(event) {
    if (event.target.files[0].size > 5242880) {
      this.uploadRecipt = true;
    } else {
      this.uploadRecipt = false;
      this.Reciept = event.target.files[0];
      this.RecieptName = this.Reciept.name;
    }
  }

  assignType(event){
    console.log(event.value);
    if(event.value == 'receipt'){
      this.receipt = true;
      this.reqHistory = false;

    }else if(event.value=='reqHistory'){
      this.reqHistory = true;
      this.receipt = false;
      this.getWalletRechargeStatusApi('NOTAPPROVED');

    }
    
  }
  getWalletRechargeStatusApi(status){
    this.auth.getWalletRechargeStatus2(status).subscribe((res:any)=>{
      if(res.status_code==1){
        console.log("status:::::",res);
      this.WalletRechargeStatus=res.object;
      this.wallet=false;

      }
      else if(res.status_code==0){
        this.wallet=true;
        console.log(this.wallet,'vale')

        this.WalletRechargeStatus=res.object;
      }
      
    },err=>{
      console.log(err);
    })
  }
  previousWalletRequestStatus(event){
    console.log(event.value);
    if(event.value == 'openReq'){
      this.openReq = true;
      this.closeReq = false;
      this.rejectReq = false;
      this.getWalletRechargeStatusApi('NOTAPPROVED');

    }else if(event.value=='closeReq'){
      this.closeReq = true;
      this.openReq = false;
      this.rejectReq = false;
      this.getWalletRechargeStatusApi('APPROVED');

    }
    else if(event.value == 'rejectReq'){
      this.rejectReq = true;
      this.closeReq = false;
      this.openReq = false;
      this.getWalletRechargeStatusApi('REJECTED');

    }

  }

}
